import { render, staticRenderFns } from "./weiList.vue?vue&type=template&id=3c0521a2&scoped=true"
import script from "./weiList.vue?vue&type=script&lang=js"
export * from "./weiList.vue?vue&type=script&lang=js"
import style0 from "./weiList.vue?vue&type=style&index=0&id=3c0521a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0521a2",
  null
  
)

export default component.exports